import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { shopTarifierungGEGE } from './shopTarifierungGEGE';
import { streckenTarifierungGEGE } from './streckenTarifierungGEGE';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchGegenstaendeCategoriesRequested } from './gegenstaendeRequestedSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { handleGegeNavigationToAngebotSaga } from './handleGegeNavigationToAngebotSaga';

export function* rootSaga() {
  yield all([
    watchInDashboardUebernehmenSaga(),
    watchVorschlagdatenChanged(),
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    shopTarifierungGEGE(),
    streckenTarifierungGEGE(),
    watchAntragsnummerRequested(),
    watchGegenstaendeCategoriesRequested(),
    watchDruckdatenChanged(),
    watchVorbelegungRequested(),
    handleGegeNavigationToAngebotSaga(),
  ]);
}
